import { defineMessages } from '@/i18n'

/** Тексты панели настроек элементов дизайн-блока. */
export const messages = defineMessages({
  ru: {
    backdropNone: 'Нет',
    backdropLight: 'Светлый',
    backdropDark: 'Тёмный',
    backdropPrimary: 'Акцент',
    backdropBlur: 'Контур',
    backdrop: 'Подложка',
    backdropAria: (label: string) => `Подложка: ${label}`,
    badgesCount: (n: number, max: number) => `Бейджи (${n}/${max})`,
    add: 'Добавить',
    badgeIcon: 'Иконка бейджа',
    badgeText: 'Текст бейджа',
    charsLeftAria: 'Осталось символов',
    removeBadge: 'Удалить бейдж',
    badgeStyle: 'Стиль бейджа',
    badgeSample: 'Бейдж',
    charsLeft: 'Символов осталось',
    unsupportedElement:
      'Для этого типа элемента редактора нет. Его можно удалить в канвасе — наведите на элемент и нажмите корзину.',
    backToElements: 'Назад к списку элементов',
    unsupportedType: 'Тип не поддерживается студией',
    addElement: 'Добавить элемент:',
    elementsLimit: (n: number) => `Достигнут предел ${n} элементов в блоке.`,
    align: 'Выравнивание',
    textSize: 'Размер текста',
    iconSearchPlaceholder: 'Поиск: книга, огонь, star…',
    iconCatalog: 'Каталог иконок',
    noIcon: 'Без иконки',
    nothingFound: 'Ничего не найдено',
    image: 'Изображение',
    imageHint:
      'Максимальное соотношение сторон — 1:1: высота картинки не больше её ширины. Подойдут квадратные и горизонтальные (1:1, 4:3, 16:9). Вертикальные (3:4, 9:16) будут обрезаны автоматически.',
    tilt: 'Наклон',
    rows: 'Строки',
    addRow: 'Добавить строку',
    removeRow: 'Удалить строку',
    columns: 'Столбцы',
    addColumn: 'Добавить столбец',
    removeColumn: 'Удалить столбец',
    tableHint: 'Размер текста подбирается автоматически: чем больше столбцов, тем мельче текст.',
    formatting: 'Форматирование',
    formattingHint: 'Выделите текст слева и нажмите кнопку',
    cardHeading: 'Заголовок',
    cardHeadingDesc: 'Крупный заголовок',
    cardText: 'Текст',
    cardTextDesc: 'Параграф текста',
    cardImage: 'Картинка',
    cardImageDesc: 'Изображение',
    cardBadge: 'Бейдж',
    cardBadgeDesc: 'Метка или тег',
    cardTable: 'Таблица',
    cardTableDesc: 'Таблица данных',
    alignLeft: 'Слева',
    alignCenter: 'По центру',
    bold: 'Жирный',
    italic: 'Курсив',
    highlight: 'Маркер',
    underline: 'Подчёркивание',
    wavy: 'Волна',
  },
  en: {
    backdropNone: 'None',
    backdropLight: 'Light',
    backdropDark: 'Dark',
    backdropPrimary: 'Accent',
    backdropBlur: 'Outline',
    backdrop: 'Backdrop',
    backdropAria: (label: string) => `Backdrop: ${label}`,
    badgesCount: (n: number, max: number) => `Badges (${n}/${max})`,
    add: 'Add',
    badgeIcon: 'Badge icon',
    badgeText: 'Badge text',
    charsLeftAria: 'Characters left',
    removeBadge: 'Remove badge',
    badgeStyle: 'Badge style',
    badgeSample: 'Badge',
    charsLeft: 'Characters left',
    unsupportedElement:
      'There’s no editor for this element type. You can delete it on the canvas — hover over the element and click the trash icon.',
    backToElements: 'Back to elements',
    unsupportedType: 'This type isn’t supported in the studio',
    addElement: 'Add element:',
    elementsLimit: (n: number) => `You’ve reached the limit of ${n} elements per block.`,
    align: 'Alignment',
    textSize: 'Text size',
    iconSearchPlaceholder: 'Search: book, fire, star…',
    iconCatalog: 'Icon catalog',
    noIcon: 'No icon',
    nothingFound: 'Nothing found',
    image: 'Image',
    imageHint:
      'Maximum aspect ratio is 1:1: the image can’t be taller than it is wide. Square and horizontal images work (1:1, 4:3, 16:9). Vertical ones (3:4, 9:16) are cropped automatically.',
    tilt: 'Tilt',
    rows: 'Rows',
    addRow: 'Add row',
    removeRow: 'Remove row',
    columns: 'Columns',
    addColumn: 'Add column',
    removeColumn: 'Remove column',
    tableHint: 'Text size adjusts automatically: the more columns, the smaller the text.',
    formatting: 'Formatting',
    formattingHint: 'Select text on the left and click a button',
    cardHeading: 'Heading',
    cardHeadingDesc: 'Large heading',
    cardText: 'Text',
    cardTextDesc: 'Paragraph of text',
    cardImage: 'Image',
    cardImageDesc: 'Picture',
    cardBadge: 'Badge',
    cardBadgeDesc: 'Label or tag',
    cardTable: 'Table',
    cardTableDesc: 'Data table',
    alignLeft: 'Left',
    alignCenter: 'Center',
    bold: 'Bold',
    italic: 'Italic',
    highlight: 'Highlight',
    underline: 'Underline',
    wavy: 'Wavy underline',
  },
})
